import { useMutation } from "react-query";
import api from "../api/api";

export const usePostTranssaction = () => useMutation(api.transacciones.postTransaction)

export const useDeleteTranssaction = () => useMutation(api.transacciones.deleteTransaction)